module.exports = __webpack_public_path__ + "img/xlinq.b415a4f5.svg";